import http from "../../helpers/http";

import {
    FETCH_HOME_NEW_CONTENT,
    FETCH_HOME_NEW_CONTENT_SUCCESS,
    FETCH_HOME_NEW_CONTENT_FAILED
} from "./actionTypes";

export const fetchHomeNew = () => (dispatch) => {
    dispatch({
        type: FETCH_HOME_NEW_CONTENT,
        payload: null
    });
    http
        .get("home-page-new")
        .then(({ data }) => {
            dispatch({
                type: FETCH_HOME_NEW_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_HOME_NEW_CONTENT_FAILED,
                payload: error
            });
        });
};
